angular.module('TetherApp').factory(
    'sweepstakesService',
    [
        '$http',
        function ($http) {

            let randomString = function randomString(length, chars) {
                let result = '';
                for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
                return result;
            };

            let indexSweepstakes = function (page) {
                let uri = '/api/v1/experience/sweepstakes/' +
                    randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                if (page != undefined) {
                    uri += '?page=' + page;
                }
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let storeSweepstakes = function (data) {
                return $http.post(
                    '/api/v1/experience/sweepstakes',
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    })
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let updateSweepstakes = function (data) {
                let uri = '/api/v1/experience/sweepstakes/' + data.experience.eid;
                return $http.put(
                    uri,
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let deleteSweepstakes = function (sweepstakesId) {
                let uri = '/api/v1/experience/sweepstakes/' + sweepstakesId + '/' +
                    randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                return $http.delete(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    })
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let getPrizePools = function (sweepstakesId) {
                return $http.post(
                    '/api/v1/experience/sweepstakes/' + sweepstakesId + '/prize-pool',
                    {},
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                ).then(
                    function (response) {
                        return response.data;
                    }
                );
            };

            let getNewEntryForValidation = function (giftWithPurchaseId, data) {
                let uri = '/api/v1/experience/sweepstakes/' + giftWithPurchaseId + '/entry-for-validation/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' },
                        params: data
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let getEntryForValidation = function (giftWithPurchaseId, experienceParticipantId) {
                let uri = '/api/v1/experience/sweepstakes/' + giftWithPurchaseId + '/entry-for-validation/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    )
                    + '?experienceParticipantId=' + experienceParticipantId;

                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' },
                        params: data
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let postEntryForValidation = function (giftWithPurchaseId, data) {
                let uri = '/api/v1/experience/sweepstakes/' + giftWithPurchaseId + '/entry-for-validation/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );

                return $http.post(
                    uri,
                    data,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let getMatchingImages = function (data) {
                let uri = '/api/v1/experience/sweepstakes/matching-images/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                return $http.post(
                    uri,
                    {"images": data},   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            // START: REPORTING
            let statsSweepstakes = function (sweepstakesId) {
                let uri = '/api/v1/experience/sweepstakes/' + sweepstakesId + '/get-report/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    )
                    + '?report_name=stats&report_type=json';
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let graphSweepstakes = function (sweepstakesId) {
                let uri = '/api/v1/experience/sweepstakes/' + sweepstakesId + '/get-report/'
                    + randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    )
                    + '?report_name=graph&report_type=json';
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };
        // END: REPORTING

        // START: NEW DRAW
        var draw = function (clientId, experienceId, drawId) {
            return $http.post('/' + clientId + '/sweepstakes/' + experienceId + '/draw/' + drawId + '/draw-potential-winners', {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        var ballotDraws = function (clientId, experienceId, drawId) {
            return $http.get('/' + clientId + '/sweepstakes/' + experienceId + '/draw/' + drawId + '/ballot-draws', {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

        var other = function (clientEid, experienceEid, entryEid) {
            var uri = '/' + clientEid + '/api/sweepstakes/' + experienceEid + '/other-entries/' + entryEid;
            return $http.get(uri, {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        }

        function updateBallotDrawStatus(clientEid, experienceEid, ballotDrawEid, status, isAll) {
            var uri = '/' + clientEid + '/api/sweepstakes/' + experienceEid + '/ballot-draw-status/' + ballotDrawEid;
            let data = { status: status};

            if (isAll) {
                data.is_all = isAll;
            }

            return $http.put(uri, data, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        }

        let ballotDrawInvalid = function (clientEid, experienceEid, ballowDrawEid, isAll) {
            return updateBallotDrawStatus(clientEid, experienceEid, ballowDrawEid, 'invalidated', isAll);
        };

        let ballotDrawPotentialWinner = function (clientEid, experienceEid, ballowDrawEid, isAll) {
            return updateBallotDrawStatus(clientEid, experienceEid, ballowDrawEid, 'potential-winner', isAll);
        };

        function updateEntryStatus(clientEid, experienceEid, entryEid, status) {
            var uri = '/' + clientEid + '/api/sweepstakes/' + experienceEid + '/entry-status/' + entryEid;
            return $http.put(uri, { status: status }, {
                cache: false,
                headers: { 'Cache-Control': 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        }

        var valid = function (clientEid, experienceEid, entryEid) {
            return updateEntryStatus(clientEid, experienceEid, entryEid, 'valid');
        }

        var invalid = function (clientEid, experienceEid, entryEid) {
            return updateEntryStatus(clientEid, experienceEid, entryEid, 'invalid');
        }

        var kicked = function (id, data) {
            var uri = '/api/v1/experience/sweepstakes/' + id + '/prizing/kicked';
            return $http.post(uri, data, {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' }
            }).then(function (response) {
                return response.data;
            });
        };

            let confirm = function (clientId, id, data) {
                let uri = '/' + clientId + '/api/sweepstakes/' + id + '/confirm-winners';
                return $http.post(uri, data, {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }).then(function (response) {
                    return response.data;
                });
            };
            // END: NEW DRAW

            return {
                indexSweepstakes: indexSweepstakes,
                storeSweepstakes: storeSweepstakes,
                updateSweepstakes: updateSweepstakes,
                deleteSweepstakes: deleteSweepstakes,
                getPrizePools: getPrizePools,
                getNewEntryForValidation: getNewEntryForValidation,
                getEntryForValidation: getEntryForValidation,
                postEntryForValidation: postEntryForValidation,
                getMatchingImages: getMatchingImages,
                statsSweepstakes: statsSweepstakes,
                graphSweepstakes: graphSweepstakes,
                draw: draw,
                other: other,
                ballotDrawInvalid: ballotDrawInvalid,
                ballotDrawPotentialWinner: ballotDrawPotentialWinner,
                valid: valid,
                invalid: invalid,
                kicked: kicked,
                confirm: confirm,
                ballotDraws: ballotDraws
            };

        }
    ]
);
